<template>
  <div class="header">
    <div class="header-one">
      <div class="brand">
        <el-tag v-if="catName"
                color="#FF7D00"
                class="keyWords">
          {{catName}}
        </el-tag>
        <span> > </span>
        <el-tag v-if="brandName"
                class="keyWords"
                color="#69C0FF"
                v-html="brandName">
        </el-tag>
        <span v-if="brandName"> > </span>
        <span v-if="postWord"
              class="postWord"
              v-html="postWord">
          <!-- {{$t('baseInfo.postKeyWordLabel')+postWord}} -->
        </span>
        <span>|</span>
        <span class="follow"> <span>
            <i class="iconfont icon-heart iconBox"
               v-show="isFollow"
               @click="followClick(1)"></i>
            <i class="iconfont icon-heart-fill red iconBox"
               v-show="!isFollow"
               @click="followClick(0)"></i>
          </span>+{{$t('mainHead.follow')}}</span>
      </div>
    </div>

    <div class="header-two">
      <!-- <div style="width:100%"> -->
      <el-tabs v-model="editableTabsValue"
               type="card"
               @tab-click="handleTabClick">
        <el-tab-pane :key="item.name"
                     v-for="(item) in editableTabsList"
                     :label="item.title"
                     :name="item.name">

        </el-tab-pane>
      </el-tabs>
    </div>

  </div>
</template>

<script>
import Vue from 'vue'
import { setMarked, getSearchMarked } from '@/api/public'
import { getUrlParams, getObjFromUrl, build_ts } from '@/utils'
export default {
  data() {
    return {
      ts: this.$store.state.user.ebayTs,
      editableTabs: [
        {
          title: this.$t('mainHead.tabs_trend'),
          name: 'EbayTrendList',
          isShow: true,
        },
        {
          title: this.$t('mainHead.tabs_commodity'),
          name: 'EbayCommodityList',
          isShow: true,
        },
        {
          title: this.$t('mainHead.tabs_category_son'),
          name: 'EbayCategoryList',
          isShow: true,
        },
        {
          title: this.$t('mainHead.tabs_brand'),
          name: 'EbayBrandList',
          isShow: true,
        },
      ],
      postWord: this.$store.state.user.ebayWord,
      catName: this.$store.state.user.ebayCName,
      brandName: this.$store.state.user.ebayBName,
      editableTabsValue: 'EbayTrendList',
      ActivedTabArr: [],
      isFollow: true,
    }
  },
  computed: {
    editableTabsList: function () {
      return this.editableTabs.filter(function (item) {
        return item.isShow //返回isShow=true的项，添加到activeUsers数组
      })
    },
  },
  methods: {
    followClick(val) {
      var reg = /^["|'](.*)["|']$/g
      let param = {
        category_id: getUrlParams('ebayCId'),
        func: val,
        platform: getUrlParams('ebayPlat'),
        type: 'word',
        word: this.$store.state.user.ebayWord.replace(reg, '$1'),
      }
      setMarked(param)
        .then((res) => {
          if (res.status == 'ok') {
            this.isFollow = !this.isFollow
            this.$message.success('设置成功')
          } else {
            this.$message.error('操作失败')
          }
        })
        .catch((e) => {
          this.$message.error(e.data.error_msg.msg)
        })
    },
    getMarked() {
      getSearchMarked({
        category_id: getUrlParams('ebayCId'),
        plat: 'ebay',
        word: this.$store.state.user.ebayWord.replace(
          /^["|'](.*)["|']$/g,
          '$1'
        ),
      })
        .then((res) => {
          if (res.status == 'ok') {
            if (res.result.data.monitor_flag == '1') {
              this.isFollow = false
            } else {
              this.isFollow = true
            }
          } else {
            this.$message.error('请求失败')
          }
        })
        .catch((e) => {
          // this.$message.success('删除失败')
        })
    },
    changeActivedTabArr() {
      var self = this
      if (this.ActivedTabArr && this.ActivedTabArr.length > 0) {
        this.ActivedTabArr.forEach(function (item) {
          Vue.set(self.editableTabs[item], 'isShow', false)
        })
      }
    },
    /*
     type:查询类型  id:通过id精确查询，name：通过名称模糊查询
    */
    handleTabClick(tab, event) {
      localStorage.setItem('ebayActivedTab', tab.name)
      this.$store.dispatch('user/changeEbayActivedTab', tab.name)
    },
  },
  watch: {
    '$store.state.user.ebayCName': {
      handler(newVal, oldVal) {
        this.catName = newVal
      },
    },
    '$store.state.user.ebayBName': {
      handler(newVal, oldVal) {
        this.brandName = newVal
      },
    },
    '$store.state.user.ebayWord': {
      handler(newVal, oldVal) {
        this.postWord = newVal
      },
    },
    '$store.state.user.ebayActivedTab': {
      handler(newVal, oldVal) {
        this.editableTabsValue = newVal
      },
    },
    // '$store.state.user.ActivedTabArr': {
    //   handler(newVal, oldVal) {
    //     this.ActivedTabArr = newVal
    //     this.changeActivedTabArr()
    //   },
    // },
  },
  mounted() {
    this.getMarked()
  },
  created() {
    if (getUrlParams('ebayWord')) {
      this.postWord = getUrlParams('ebayWord')
    } else {
      if (localStorage.getItem('ebayWord')) {
        this.postWord = localStorage.getItem('ebayWord')
      }
    }
    if (getUrlParams('ebayCName')) {
      this.catName = getUrlParams('ebayCName')
    } else {
      if (localStorage.getItem('ebayCName')) {
        this.catName = localStorage.getItem('ebayCName')
      }
    }
    // if (
    //   localStorage.getItem('ebayActivedTabArr') &&
    //   localStorage.getItem('ebayActivedTabArr').length > 0
    // ) {
    //   this.ActivedTabArr = localStorage.getItem('ebayActivedTabArr')
    // }
  },
}
</script>

<style scoped lang='less'>
.keyWords {
  color: #fff;
}
.postword {
  color: #252525;
}
.follow {
  color: #85868a;
}
.iconBox {
  cursor: pointer;
  margin-right: 4px;
}
.lb {
  display: inline-block;
}
.red {
  color: #ff7875;
}
</style>
